import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploader.vue?vue&type=style&index=0&id=bab9d062&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab9d062"]])

export default __exports__